import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import avo from 'analytics/avo';
import Link from 'components/consumer/Link';
import IconUserAccount from 'components/icons/iconUserAccount';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
const MobileNavbarLink = t0 => {
  const $ = _c(21);
  const {
    children,
    id,
    isNested: t1,
    to,
    currentPage
  } = t0;
  const isNested = t1 === undefined ? false : t1;
  const locationFromRoute = useUserCurrentPageType();
  const location = currentPage ?? locationFromRoute;
  let t2;
  if ($[0] !== to) {
    t2 = typeof to === "string" && (to.startsWith("/customer") || to.startsWith("/quote") || to.startsWith("/wishlist")) && !to.startsWith("/customer-photos/") && !to.startsWith("/customer/reset-password/customer/");
    $[0] = to;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isProtectedRoute = t2;
  let t3;
  if ($[2] !== children || $[3] !== location || $[4] !== to) {
    t3 = children === "Room Visualizer" || children === "Room Refresh" ? () => {
      avo.ctaClicked({
        text: children,
        targetUrl: to,
        cta: "Room Visualizer",
        location,
        component: "Navbar"
      });
    } : undefined;
    $[2] = children;
    $[3] = location;
    $[4] = to;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isNested) {
    t4 = classNames("text-lg !text-gray flex justify-start px-5 py-3 no-underline hover:underline focus-visible:rounded-[3px] focus-visible:outline-offset-[-4px] flex-col items-start max-w-full", {
      "pt-2 px-[42px] pb-[9px]": isNested
    });
    $[6] = isNested;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isProtectedRoute) {
    t5 = isProtectedRoute ? {
      prefetch: false
    } : {};
    $[8] = isProtectedRoute;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== id) {
    t6 = id === "login" && <IconUserAccount className="mr-4 relative top-[-2px]" />;
    $[10] = id;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== children) {
    t7 = <span className="MobileNavbarLink__text">{children}</span>;
    $[12] = children;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7 || $[19] !== to) {
    t8 = <Link to={to} onClick={t3} className={t4} id={to} {...t5}>{t6}{t7}</Link>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = to;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
MobileNavbarLink.propTypes = {
  children: PropTypes.string,
  id: PropTypes.string,
  isNested: PropTypes.bool,
  to: PropTypes.string,
  currentPage: PropTypes.objectOf(PropTypes.object)
};
export default MobileNavbarLink;